import { Divider, Grid, Stack, Typography } from "@mui/material";
import ReservationDateRange from "../../../../../text/ReservationDateRange";

export default function ReservationSummary({ reservation }) {
  if(!reservation) return null;

  return (
    <Stack key={reservation.id}>
      <Stack>
        {reservation.start_at ? <ReservationDateRange reservation={reservation} hideTime />:
        <Typography variant="body1" fontWeight="700">
          Unscheduled reservation
        </Typography>}
      </Stack>
      <Stack pl={1}>
        {reservation.reservation_items?.map((reservationItem) => (
          <Grid container key={reservationItem.id}>
            <Grid item sm={10}>
              <Typography variant="body1">
                {reservationItem.quantity}x {reservationItem.item?.name}
              </Typography>
            </Grid>
            <Grid item sm={2}>
              <Typography variant="body1">
                ${reservationItem.total_price_dollars}
              </Typography>
            </Grid>
          </Grid>
        ))}
      </Stack>
      <Divider />
      <Stack pl={1} mb={1}>
        <Grid container>
          <Grid item sm={10}>
            <Typography variant="body1">
              Subtotal
            </Typography>
          </Grid>
          <Grid item sm={2}>
            <Typography variant="body1">
              ${reservation.total_price_dollars}
            </Typography>
          </Grid>
        </Grid>
      </Stack>
      <Stack pl={1} mb={1}>
        <Grid container>
          <Grid item sm={10}>
            <Typography variant="body1">
              Fees
            </Typography>
          </Grid>
          <Grid item sm={2}>
            <Typography variant="body1">
              ${reservation.order.total_fees}
            </Typography>
          </Grid>
        </Grid>
        <Grid container>
          <Grid item sm={10}>
            <Typography variant="body1">
              Taxes
            </Typography>
          </Grid>
          <Grid item sm={2}>
            <Typography variant="body1">
              ${reservation.order.total_tax_dollars}
            </Typography>
          </Grid>
        </Grid>
      </Stack>
      <Stack>
        <Grid container>
          <Grid item sm={10}>
            <Typography variant="h6" fontWeight="700">
              Total
            </Typography>
          </Grid>
          <Grid item sm={2}>
            <Typography variant="h6" fontWeight="700">
              ${reservation.order.total_price_with_fees_dollars}
            </Typography>
          </Grid>
        </Grid>
      </Stack>
    </Stack>
  );
}